module.exports = __webpack_public_path__ + "static/media/video-button.0c57e389.png";